import { useMemo, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { avatar } from "@/assets";
import CurrencyInput from "react-currency-input-field";
import { Separator } from "@/components/ui/separator";
import { Loader } from "lucide-react";

import { logoSymbol, moneyBag } from "@/assets";
import { motion } from "framer-motion";
import { useMediaQuery } from "react-responsive";
import { MdSave } from "react-icons/md";
import { remoteAddress } from "@/constants";
import { ImSpinner6 } from "react-icons/im";
import { Loading } from "notiflix";
import axios from "axios";
import { toast } from "sonner";
import PaymentInfo from "@/components/forms/PaymentInfo";
import { useSelector } from "react-redux";
import { GetRequest } from "@/lib/http";
import { Report } from "notiflix";
import { useEffect } from "react";
import { resolveImageUrl } from "@/lib/utils";

const PaymentDetails = () => {
  const user = useSelector((state) => state.user.user);
  const [amount, setAmount] = useState(null);
  const [open, setOpen] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("ePay");
  const [showDrawer, setShowDrawer] = useState(false);
  const [error, setError] = useState("");
  const [simpleLoad, setSimpleLoad] = useState(false);
  const [tooltip, setTooltip] = useState(false);
  const [refLoading, setRefLoading] = useState(false);

  const data = {};

  const [accountDetails, setAccountDetails] = useState({
    bank_name: "",
    acct_name: "",
    acct_number: "",
  });
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px)",
  });

  const [referrals, setReferrals] = useState([]);

  const formatter = new Intl.NumberFormat("en-US");

  const copyToClipboard = (link) => {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        setTooltip(true);
        setTimeout(() => {
          setTooltip(false);
        }, 2000); // Hide tooltip after 2.5 seconds
      })
      .catch((error) => {
        console.error("Error copying to clipboard:", error);
      });
  };

  async function fetchRefferals() {
    const { data, err } = await GetRequest({
      url: "/api/referrals",
      setState: setRefLoading,
      errorMessage: "Unable to fetch referrals at the moment",
    });
    if (!err) {
      setReferrals(data);
    } else {
      Report.failure("Error", err);
    }
  }

  useEffect(() => {
    fetchRefferals();
  }, []);

  const referral = useMemo(() => {
    const url = new URL(window.location.href);
    return `${url.protocol}//${url.host}/register?ref=${user?.username}`;
  }, [user?.referral_code]);

  return (
    <section className="pb-7 md:pb-0">
      <div className="relative flex flex-col-reverse gap-6 lg:flex-row">
        {/* <div className="md;shadow-2xl w-full rounded-xl border p-5 shadow-lg dark:border-darkBorder  lg:p-7">
          <form onSubmit={handlePayment} className="space-y-1.5">
            <h3 className="text-sm font-semibold">Enter Amount</h3>

            <div className="mt-1 flex flex-col">
              <div className="flex items-center gap-x-3 rounded-md border bg-gray-100 p-2 py-2.5 dark:border-darkBorder dark:bg-darkInput">
                <CurrencyInput
                  name="amount"
                  placeholder="Input amount (₦)"
                  value={amount}
                  onValueChange={(e) => setAmount(e)}
                  className="w-full border-none bg-transparent text-sm outline-none dark:text-white"
                  required
                  prefix="₦ "
                />
              </div>
            </div>

            <p className="py-3 text-sm font-medium">How do you want to pay?</p>

            <div className="flex flex-row gap-3 pt-2">
              <div title="ePay">
                <input
                  type="radio"
                  id="flexRadioDefault1"
                  checked={paymentMethod === "ePay"}
                  onChange={() => setPaymentMethod("ePay")}
                />
                <label className="px-2" htmlFor="flexRadioDefault1">
                  ePay{" "}
                  <small>
                    (Online payment with Credit/Debit card and more)
                  </small>
                </label>
              </div>

              <div title="Bank Transfer">
                <input
                  type="radio"
                  id="flexRadioDefault2"
                  checked={paymentMethod === "Bank Transfer"}
                  onChange={() => setPaymentMethod("Bank Transfer")}
                />
                <label htmlFor="flexRadioDefault2" className="px-2 text-sm">
                  Bank Transfer
                </label>
              </div>
            </div>

            <div className="pt-4">
              <button
                type="submit"
                className="rounded-md bg-primary px-4 py-2.5 text-sm font-medium text-white"
              >
                {simpleLoad || loading ? (
                  <div className="flex items-center gap-2">
                    <Loader size={16} className="animate-spin" />
                    <p>Processing</p>
                  </div>
                ) : (
                  "Proceed"
                )}
              </button>
            </div>
          </form>
        </div> */}

        {/* Referrals */}
        <div className="lg:w-[70%]">
          <form
            className="dark:border-darkBorder mb-3 w-full rounded-xl border p-4 shadow-lg md:shadow-xl"
            onSubmit={async (e) => {
              e.preventDefault();
              try {
                Loading.standard("Saving Details");
                const formData = new FormData(e.target);
                const { data } = await axios.post(
                  `/api/user/update/${user.id}`,
                  formData,
                );
                if (!data.err) {
                  toast.success("Details saved successfully");
                } else {
                  toast.error(data.err);
                }
              } catch (error) {
                toast.error("Unable to save details, please try again");
                console.log(error);
              } finally {
                Loading.remove();
              }
            }}
          >
            <h1 className="text-xl font-bold">Withdrawal Bank Details</h1>

            {/* <div className="pt-2">
              <label
                htmlFor="acc_name"
                className="text-sm text-black/80 dark:text-white"
              >
                Account Name
              </label>
              <input
                defaultValue={user.withdrawal_account_name}
                name="withdrawal_account_name"
                type="text"
                className="dark:border-darkBorder w-full rounded-md border border-gray-300 bg-transparent p-2 text-black outline-none dark:text-white"
                id="acc_name"
                required
              />
            </div>
            <div className="py-2">
              <label
                htmlFor="acc_number"
                className="text-sm text-black/80 dark:text-white"
              >
                Account Number
              </label>
              <input
                defaultValue={user.withdrawal_account_number}
                name="withdrawal_account_number"
                type="text"
                className="dark:border-darkBorder w-full rounded-md border border-gray-300 bg-transparent p-2 text-black outline-none dark:text-white"
                id="acc_number"
                required
              />
            </div>
            <div>
              <label
                htmlFor="bank_name"
                className="text-sm text-black/80 dark:text-white"
              >
                Bank Name
              </label>
              <input
                defaultValue={user.withdrawal_bank_name}
                name="withdrawal_bank_name"
                type="text"
                className="dark:border-darkBorder w-full rounded-md border border-gray-300 bg-transparent p-2 text-black outline-none dark:text-white"
                id="bank_name"
                required
              />
            </div>
            <button
              type="submit"
              className="btn my-3 flex w-full items-center justify-center rounded-md py-2 text-white"
            >
              <MdSave size={20} /> Save
            </button> */}
            <div className="py-5 text-center opacity-80">
              This option is coming soon, stay tuned
            </div>
          </form>

          <div className="dark:border-darkBorder w-full rounded-xl border p-4 shadow-lg md:shadow-2xl">
            <h1 className="text-xl font-bold">
              Referrals ({referrals?.length} Referrals)
            </h1>

            <p className="my-1 text-sm opacity-80">
              Below are a list of all your referrals. You stand a chance of
              receiving bonuses on their purchases on Billzpay
            </p>

            {refLoading ? (
              <div className="flex h-32 items-center justify-center text-center md:h-40">
                <ImSpinner6 size={30} className="animate-spin" />
              </div>
            ) : (
              <div>
                {referrals?.map((ref) => {
                  return (
                    <div key={ref.id} className="border-b py-3">
                      <div className="flex items-center gap-2">
                        <img
                          className="h-[50px] w-[50px] rounded-full"
                          src={user.avatar ? resolveImageUrl(user.avatar) : avatar}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = avatar;
                          }}
                        />
                        <h1>
                          <b>{ref.username}</b> ({ref.firstName} {ref.last_name}
                          )
                        </h1>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        <div className="flex w-full flex-col gap-6 lg:w-[30%]">
          <div className="dark:border-darkBorder dark:bg-darkBg overflow-hidden rounded-lg border bg-white px-[23px] py-[25px] pb-[17px]">
            <div className="widget-content">
              <div className="relative flex h-28 justify-between">
                <div className="before:absolute before:top-[-50px] before:left-[-60px] before:size-[150px] before:rounded-full before:bg-[#f2eafa] before:dark:bg-[#312d55]">
                  <span className="absolute top-[-5px] left-[-9px] inline-block">
                    <img
                      src={moneyBag}
                      alt="money-bag"
                      className="size-[70px]"
                    />
                  </span>
                </div>

                <div className="text-left">
                  <h6 className="text-primary mb-0 text-[16px] font-medium dark:text-green-200">
                    Commission Balance
                  </h6>
                  <p className="mb-0 text-[25px] font-semibold text-black/85 dark:text-white">
                    ₦ {formatter.format(user?.commission)}
                  </p>
                </div>
              </div>

              <div className="flex justify-end">
                <h2 className="rounded-md bg-[#54d62c29] p-1 text-xs font-bold text-[#229a16]">
                  Billzpay
                </h2>
              </div>
            </div>
          </div>

          <div className="shadow-custom dark:border-darkBorder w-full rounded-xl border p-3 pt-2">
            <h1 className="text-base font-semibold">
              Share and Earn Commission
            </h1>

            <Separator className="mt-2 mb-4" />

            <div>
              <input
                type="text"
                className="dark:border-darkBorder dark:bg-darkInput w-[98%] rounded-md border bg-gray-100 p-2 px-3 py-2 outline-none"
                value={referral}
                readOnly
              />
            </div>

            <div className="flex justify-end pt-2">
              <button
                className="bg-primary rounded-md px-4 py-2 text-sm text-white"
                onClick={() => copyToClipboard(referral)}
              >
                Copy
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Pop-up */}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="font-jakarta dark:bg-darkBg w-[100%] border-none md:max-w-[600px]">
          <DialogHeader>
            <DialogTitle className="text-darkInput text-xl font-bold dark:text-white">
              <div className="flex items-center justify-between pt-5 pb-5">
                <h1>Bank Account Details</h1>
                <h2 className="rounded-md bg-[#54d62c29] p-1 text-xs font-bold text-[#229a16]">
                  Billzpay
                </h2>
              </div>
              <Separator />
            </DialogTitle>
          </DialogHeader>

          <div className="dark:bg-darkInput rounded-xl bg-gray-100 p-6 text-sm dark:text-gray-200">
            <h2 className="pb-2">
              Dear <strong>{user?.last_name}</strong>,
            </h2>

            <p className="py-2">
              To fund your wallet, kindly pay{" "}
              <strong>₦{formatter.format(amount)}</strong> into the bank account
              below through bank deposit/transfer, online transfer, mobile app
              transfer, etc.
            </p>

            <Separator className="my-4" />

            <h3 className="py-1">Bank Account Details:</h3>
            <p>
              <strong>Account Name:</strong> {accountDetails.acct_name}
              <br />
              <strong>Account Number:</strong> {accountDetails.acct_number}
              <br />
              <strong>Bank Name:</strong> {accountDetails.bank_name}
            </p>

            <Separator className="my-4" />

            <p>
              After making the payment,{" "}
              <span
                onClick={() => {
                  setOpen(false);
                  setShowDrawer(true);
                }}
                className="font-medium text-blue-400"
              >
                please fill out the payment details form
              </span>{" "}
              and your wallet will be credited once the payment is confirmed.
            </p>

            <Separator className="my-4" />

            <h3>Support:</h3>
            <p>
              If you have any questions or need assistance, please contact us:
            </p>
            <p>
              <strong>Phone:</strong> 08084121526
              <br />
              <strong>Email:</strong>{" "}
              <a href="mailto:support@epins.com.ng">support@epins.com.ng</a>
            </p>
          </div>
        </DialogContent>
      </Dialog>

      {/* USer Info Drawer */}
      {showDrawer && (
        <PaymentInfo
          onClose={() => setShowDrawer(false)}
          initialAmount={amount}
        />
      )}

      {/* Mobile Tooltip */}
      {tooltip && (
        <motion.div
          className={`dark:border-darkBorder dark:bg-darkBg absolute bottom-3 left-[32%] flex w-fit -translate-x-1/2 items-center gap-2 rounded-xl border bg-white px-2 py-2 pr-4 ${isMobile ? "" : "hidden"
            }`}
          initial={{ y: 30, opacity: 0 }} // Start off-screen
          animate={{ y: 0, opacity: 1 }} // Slide up and fade in
          exit={{ y: 30, opacity: 0 }} // Slide down and fade out
          transition={{ duration: 0.4 }} // Animation duration
        >
          <div className="dark:bg-darkBorder rounded-full bg-gray-200 p-2">
            <img src={logoSymbol} alt="logo-symbol" className="size-5" />
          </div>

          <div>
            <p className="text-sm font-medium">Link Copied</p>
          </div>
        </motion.div>
      )}

      {/* Tablet and above Tooltip */}
      {tooltip && (
        <motion.div
          className={`dark:border-darkBorder dark:bg-darkBg absolute top-6 right-7 flex -translate-x-0 items-center gap-2 rounded-xl border bg-white px-2 py-2 pr-4 ${isTablet ? "" : "hidden"
            }`}
          initial={{ y: 30, opacity: 0 }} // Start off-screen
          animate={{ y: 0, opacity: 1 }} // Slide up and fade in
          exit={{ y: 30, opacity: 0 }} // Slide down and fade out
          transition={{ duration: 0.4 }} // Animation duration
        >
          <div className="dark:bg-darkBorder rounded-full bg-gray-200 p-2">
            <img src={logoSymbol} alt="logo-symbol" className="size-5" />
          </div>

          <div>
            <p className="text-sm font-medium">Link Copied</p>
          </div>
        </motion.div>
      )}
    </section>
  );
};

export default PaymentDetails;
